import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import AppTabs from 'general/components/AppTabs';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, {
  KTRadioType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

DialogAddPricingView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddPricingView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const editMode = !!item;
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [valuationObjectType, setValuationObjectType] = useState('OPERATOR');
  const { operatorList, operatorOptions } = useAgency();
  const [selectedOperatorId, setSelectedOperatorId] = useState('');
  const [selectedChargePoint, setSelectedChargePoint] = useState(null);
  const dropdownChargePointEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="dialog_pointId"
        name="dialog_pointId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedChargePoint?.name ?? 'Chọn trụ sạc'}
          </button>
        }
        selectedValue={selectedChargePoint}
        disabled={editMode}
        dropdownMenuItems={[{ name: 'Trụ sạc', role: 'CHARGE_POINT' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargePointList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargePoints?.map((row) => ({
                id: row?.pointId,
                name: row?.pointCode,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargePoint(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trụ sạc',
          role: 'CHARGE_POINT',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedChargePoint(null);
            })}
          </div>
        }
      />
    );
  }, [selectedChargePoint, editMode]);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const dropdownInvestorEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="dialog_investorId"
        name="dialog_investorId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedInvestor?.name ?? 'Chọn nhà đầu tư'}
          </button>
        }
        selectedValue={selectedInvestor}
        disabled={editMode}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'NĐT nhượng quyền', role: 'INVESTOR' }]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            role: AgencyConstants.AgencyRole.INVESTOR,
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedInvestor(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'NĐT nhượng quyền',
          role: 'INVESTOR',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedInvestor(null);
            })}
          </div>
        }
      />
    );
  }, [selectedInvestor, editMode]);
  const [selectedCoinvestor, setSelectedCoinvestor] = useState(null);
  const dropdownCoinvestorEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="dialog_coinvestorId"
        name="dialog_coinvestorId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedCoinvestor?.name ?? 'Chọn nhà đầu tư'}
          </button>
        }
        selectedValue={selectedCoinvestor}
        disabled={editMode}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'NĐT liên kết', role: 'COINVESTOR' }]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            role: AgencyConstants.AgencyRole.COINVESTOR,
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedCoinvestor(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'NĐT liên kết',
          role: 'COINVESTOR',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedCoinvestor(null);
            })}
          </div>
        }
      />
    );
  }, [selectedCoinvestor, editMode]);
  const overchargeTabs = ['Trụ sạc AC', 'Trụ sạc DC'];
  const [selectedOverchargeTab, setSelectedOverchargeTab] = useState(overchargeTabs[1]);
  const buildEmptyPricingConfig = () => ({
    pricingMode: ChargeConstants.ChargePricingMode.FLAT,
    flatPrice: '',
    normalPrice: '',
    peakPrice: '',
    offPeakPrice: '',
    freeOverchargeDuration: '',
    overchargePrice: '',
    isReservationOn: true,
    reservationFee: 0,
    reservationFreeCancellation: 0,
    taxRate: '8',
  });
  const [pricingConfigs, setPricingConfigs] = useState({
    AC: buildEmptyPricingConfig(),
    DC: buildEmptyPricingConfig(),
  });
  const [configuredPricingTypes, setConfiguredPricingTypes] = useState([]);
  const activeChargePointType =
    selectedOverchargeTab === 'Trụ sạc AC'
      ? ChargeConstants.ChargePointType.AC
      : ChargeConstants.ChargePointType.DC;
  const selectedChargePointType =
    selectedChargePoint?.item?.type ?? selectedChargePoint?.item?.chargeModel?.type;
  const activePricingConfig = pricingConfigs[activeChargePointType];
  const updateActivePricingConfig = (changes) => {
    setConfiguredPricingTypes((prev) =>
      prev.includes(activeChargePointType) ? prev : [...prev, activeChargePointType]
    );
    setPricingConfigs((prev) => ({
      ...prev,
      [activeChargePointType]: {
        ...prev[activeChargePointType],
        ...changes,
      },
    }));
  };
  const taxRateOptions = [
    { value: '10', name: '10%' },
    { value: '8', name: '8%' },
    { value: '5', name: '5%' },
    { value: '0', name: '0%' },
    { value: 'KCT', name: 'KCT' },
  ];
  useEffect(() => {
    if (item) {
      if (!_.isNil(item?.pointId)) {
        setValuationObjectType('CHARGE_POINT');
        setSelectedChargePoint({
          id: item?.pointId,
          name: item?.point?.pointCode,
          item: item?.point,
        });
      } else if (!_.isNil(item?.agencyId)) {
        const pricingAgency = item?.pricings?.find((pricing) => pricing?.agency)?.agency;
        const agency = {
          ...(item?.agency ?? {}),
          ...(pricingAgency ?? {}),
        };
        const agencyRoles = [
          agency?.primaryRole,
          agency?.role,
          item?.agencyRole,
          item?.scopeRole,
          item?.managedBy,
          item?.pricings?.[0]?.agencyRole,
          ...(agency?.commissions ?? []).map((commission) => commission?.role),
        ].filter(Boolean);
        if (agencyRoles.includes(AgencyConstants.AgencyRole.COINVESTOR)) {
          setValuationObjectType('COINVESTOR');
          setSelectedCoinvestor({
            id: item?.agencyId,
            name: agency?.name,
            item: agency,
          });
        } else {
          setValuationObjectType('INVESTOR');
          setSelectedInvestor({
            id: item?.agencyId,
            name: agency?.name,
            item: agency,
          });
        }
      } else if (!_.isNil(item?.operatorId)) {
        setValuationObjectType('OPERATOR');
        setSelectedOperatorId(item?.operatorId);
      }

      const groupedPricings = item?.pricings ?? [];
      const hasDcPricing = groupedPricings.some(
        (pricing) => pricing?.chargePointType === ChargeConstants.ChargePointType.DC
      );
      const hasAcPricing = groupedPricings.some(
        (pricing) => pricing?.chargePointType === ChargeConstants.ChargePointType.AC
      );
      const initialType = item?.pointId
        ? item?.point?.type ??
          groupedPricings?.[0]?.chargePointType ??
          ChargeConstants.ChargePointType.DC
        : hasDcPricing
          ? ChargeConstants.ChargePointType.DC
          : hasAcPricing
            ? ChargeConstants.ChargePointType.AC
            : ChargeConstants.ChargePointType.DC;
      setSelectedOverchargeTab(`Trụ sạc ${initialType}`);
      setPricingConfigs((prev) =>
        groupedPricings.reduce(
          (configs, pricing) => ({
            ...configs,
            [pricing.chargePointType]: {
              pricingMode: pricing?.pricingMode ?? ChargeConstants.ChargePricingMode.FLAT,
              flatPrice: pricing?.flatPrice ?? '',
              normalPrice: pricing?.normalPrice ?? '',
              peakPrice: pricing?.peakPrice ?? '',
              offPeakPrice: pricing?.offPeakPrice ?? '',
              freeOverchargeDuration: (pricing?.freeOverchargeDuration ?? 0) / 60,
              overchargePrice: pricing?.overchargePrice ?? 0,
              isReservationOn:
                !!pricing?.reservationFee || !!pricing?.reservationFreeCancellation,
              reservationFee: pricing?.reservationFee ?? 0,
              reservationFreeCancellation: pricing?.reservationFreeCancellation ?? 0,
              taxRate:
                pricing?.taxRate != null
                  ? String(pricing.taxRate).replace('%', '')
                  : '8',
            },
          }),
          prev
        )
      );
    }
  }, [item]);
  useEffect(() => {
    if (!isAdmin) {
      if (user?.agency?.primaryRole === 'INVESTOR') {
        setValuationObjectType('INVESTOR');
        setSelectedInvestor({
          id: user?.agencyId,
          name: user?.agency?.name,
          item: user?.agency,
        });
      } else if (user?.agency?.primaryRole === 'COINVESTOR') {
        setValuationObjectType('COINVESTOR');
        setSelectedCoinvestor({
          id: user?.agencyId,
          name: user?.agency?.name,
          item: user?.agency,
        });
      }
    }
  }, [user]);
  useEffect(() => {
    if (!editMode && operatorList?.length > 0) {
      setSelectedOperatorId((prev) => prev || operatorList[0]?.operatorId);
    }
  }, [operatorList, editMode]);
  useEffect(() => {
    if (
      valuationObjectType === 'CHARGE_POINT' &&
      Object.values(ChargeConstants.ChargePointType).includes(selectedChargePointType)
    ) {
      setSelectedOverchargeTab(`Trụ sạc ${selectedChargePointType}`);
    }
  }, [valuationObjectType, selectedChargePointType]);
  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);

    if (valuationObjectType === 'CHARGE_POINT' && !selectedChargePoint) {
      ToastHelper.showError('Vui lòng chọn trụ sạc');
      return;
    }
    if (valuationObjectType === 'INVESTOR' && !selectedInvestor) {
      ToastHelper.showError('Vui lòng chọn nhà đầu tư nhượng quyền');
      return;
    }
    if (valuationObjectType === 'COINVESTOR' && !selectedCoinvestor) {
      ToastHelper.showError('Vui lòng chọn nhà đầu tư liên kết');
      return;
    }
    if (valuationObjectType === 'OPERATOR' && !selectedOperatorId) {
      ToastHelper.showError('Vui lòng chọn nhà điều hành');
      return;
    }
    const chargePointTypesToSubmit =
      !editMode && valuationObjectType !== 'CHARGE_POINT'
        ? configuredPricingTypes.length > 0
          ? configuredPricingTypes
          : [activeChargePointType]
        : [activeChargePointType];

    for (const chargePointType of chargePointTypesToSubmit) {
      const config = pricingConfigs[chargePointType];
      if (
        !Utils.isValid(config?.overchargePrice) ||
        !Utils.isValid(config?.freeOverchargeDuration)
      ) {
        ToastHelper.showError(
          `Vui lòng nhập đầy đủ thông tin cấu hình giá trụ sạc ${chargePointType}`
        );
        setSelectedOverchargeTab(`Trụ sạc ${chargePointType}`);
        return;
      }
      if (
        config.pricingMode === ChargeConstants.ChargePricingMode.FLAT &&
        !Utils.isValid(config.flatPrice)
      ) {
        ToastHelper.showError(`Vui lòng nhập đầy đủ giá điện trụ sạc ${chargePointType}`);
        setSelectedOverchargeTab(`Trụ sạc ${chargePointType}`);
        return;
      }
      if (
        config.pricingMode === ChargeConstants.ChargePricingMode.HOURS &&
        (!Utils.isValid(config.normalPrice) ||
          !Utils.isValid(config.peakPrice) ||
          !Utils.isValid(config.offPeakPrice))
      ) {
        ToastHelper.showError(`Vui lòng nhập đầy đủ giá điện trụ sạc ${chargePointType}`);
        setSelectedOverchargeTab(`Trụ sạc ${chargePointType}`);
        return;
      }
      if (
        config.isReservationOn &&
        (!Utils.isValid(config.reservationFee) ||
          !Utils.isValid(config.reservationFreeCancellation))
      ) {
        ToastHelper.showError(
          `Vui lòng nhập đầy đủ thông tin đặt chỗ trụ sạc ${chargePointType}`
        );
        setSelectedOverchargeTab(`Trụ sạc ${chargePointType}`);
        return;
      }
    }

    const buildPricingParams = (chargePointType) => {
      const config = pricingConfigs[chargePointType];
      const pricingParams = {
        chargePointType,
        pricingMode: config.pricingMode,
        freeOverchargeDuration: _.toNumber(config.freeOverchargeDuration) * 60,
        overchargePrice: config.overchargePrice,
        reservationFee: config.isReservationOn ? config.reservationFee : 0,
        reservationFreeCancellation: config.isReservationOn
          ? config.reservationFreeCancellation
          : 0,
        currency: 'VND',
        taxRate: config.taxRate,
      };
      if (config.pricingMode === ChargeConstants.ChargePricingMode.FLAT) {
        pricingParams.flatPrice = config.flatPrice;
      } else if (config.pricingMode === ChargeConstants.ChargePricingMode.HOURS) {
        pricingParams.normalPrice = config.normalPrice;
        pricingParams.peakPrice = config.peakPrice;
        pricingParams.offPeakPrice = config.offPeakPrice;
      }
      return pricingParams;
    };

    const params = {
      pricings: chargePointTypesToSubmit.map(buildPricingParams),
    };
    if (valuationObjectType === 'OPERATOR') {
      params.operatorId = selectedOperatorId;
    } else if (valuationObjectType === 'CHARGE_POINT') {
      params.pointId = selectedChargePoint?.id;
    } else if (valuationObjectType === 'INVESTOR') {
      params.agencyId = selectedInvestor?.id;
    } else if (valuationObjectType === 'COINVESTOR') {
      params.agencyId = selectedCoinvestor?.id;
    }
    // console.log(params);
    // return;
    setLoading(true);
    if (!editMode) {
      const res = await ChargeHelper.API.requestCreateChargePricingGroup(params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Thêm mới cấu hình giá thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    } else {
      const res = await ChargeHelper.API.requestUpdateChargePricingGroup(params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Cập nhật cấu hình giá thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    }
    setLoading(false);
  };

  const handleToggleReservation = () => {
    const isReservationOn = !activePricingConfig.isReservationOn;
    updateActivePricingConfig({
      isReservationOn,
      ...(!isReservationOn
        ? { reservationFee: 0, reservationFreeCancellation: 0 }
        : {}),
    });
  };

  return (
    <div>
      <div className="px-4 mt-4">
        {UIHelper.buildAlert(
          <i
            className="fa-duotone fa-circle-info fa-2x"
            style={{ color: 'rgba(41, 132, 238, 1)' }}
          />,
          'Đối tượng định giá',
          <>
            Chọn{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              “Trụ sạc”{' '}
            </span>
            để thiết lập mức giá áp dụng cho riêng một trụ sạc. <br />
            Chọn{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              “Nhà đầu tư”{' '}
            </span>
            để thiết lập mức giá hộ cho một “Nhà đầu tư”. <br />
            Chọn{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              “Nhà điều hành”{' '}
            </span>
            để thiết lập mức giá áp dụng cho toàn hệ thống.
          </>,
          'rgba(41, 132, 238, 1)',
          'rgba(246, 252, 255, 1)'
        )}
      </div>

      {/* doi tuong dinh gia */}
      {isAdmin && (
        <div className="mt-4">
          {UIHelper.buildCardHeader('Đối tượng định giá', false, null, true)}
          <div className="radio-inline w-100 px-5 mb-4">
            <div className="d-flex align-items-center gap-5">
              <KTRadio
                name="valuationObjectOperator"
                label="Nhà điều hành"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                disabled={editMode}
                onChange={(value) => {
                  setValuationObjectType('OPERATOR');
                }}
                checked={valuationObjectType === 'OPERATOR'}
              />
              <KTRadio
                name="valuationObjectInvestor"
                label="NĐT nhượng quyền"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                disabled={editMode}
                onChange={(value) => {
                  setValuationObjectType('INVESTOR');
                }}
                checked={valuationObjectType === 'INVESTOR'}
              />
              <KTRadio
                name="valuationObjectCoinvestor"
                label="NĐT liên kết"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                disabled={editMode}
                onChange={(value) => {
                  setValuationObjectType('COINVESTOR');
                }}
                checked={valuationObjectType === 'COINVESTOR'}
              />
              <KTRadio
                name="valuationObjectPoint"
                label="Trụ sạc"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                disabled={editMode}
                onChange={(value) => {
                  setValuationObjectType('CHARGE_POINT');
                }}
                checked={valuationObjectType === 'CHARGE_POINT'}
              />
            </div>
          </div>
        </div>
      )}
      {isAdmin && (
        <div
          className="row m-0 p-0 px-2 mt-4"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`,
          }}
        >
          <div className="col-lg-6 mb-4 px-2">
            {valuationObjectType === 'OPERATOR' && (
              <div>
                {UIHelper.buildFormLabel('Nhà điều hành', true)}
                <KTBSDropdown
                  name="operatorId"
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {_.find(operatorList, (item) => item?.operatorId === selectedOperatorId)
                        ?.name ?? operatorList?.[0]?.name ?? 'Chọn nhà điều hành'}
                    </button>
                  }
                  selectedValue={selectedOperatorId}
                  disabled={editMode}
                  dropdownMenuItems={operatorOptions}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    setSelectedOperatorId(value);
                  }}
                  isDropdownForm={true}
                />
              </div>
            )}
            {valuationObjectType === 'CHARGE_POINT' && (
              <div>
                {UIHelper.buildFormLabel('Trụ sạc', true)}
                {dropdownChargePointEl}
              </div>
            )}
            {valuationObjectType === 'INVESTOR' && (
              <div>
                {UIHelper.buildFormLabel('Nhà đầu tư nhượng quyền', true)}
                {dropdownInvestorEl}
              </div>
            )}
            {valuationObjectType === 'COINVESTOR' && (
              <div>
                {UIHelper.buildFormLabel('NĐT liên kết', true)}
                {dropdownCoinvestorEl}
              </div>
            )}
          </div>
        </div>
      )}

      {/* cau hinh gia */}
      <div className="mt-2 pricing-config-header">
        {UIHelper.buildCardHeader('Cấu hình giá', false, null, true)}
      </div>
      <div className="px-2">
        <AppTabs
          tabs={overchargeTabs}
          activeTab={selectedOverchargeTab}
          handleClick={setSelectedOverchargeTab}
          className="pricing-overcharge-tabs"
          disabledTabs={
            valuationObjectType === 'CHARGE_POINT' && selectedChargePointType
              ? overchargeTabs.filter(
                (tab) => tab !== `Trụ sạc ${selectedChargePointType}`
              )
              : []
          }
        />
      </div>
      <div
        className="row m-0 p-0 px-2 pt-3"
        style={{
          borderBottom: `1px dashed ${AppColors.gray[300]}`,
        }}
      >
        <div className="col-lg-6 mb-4 px-2">
          <div>
            <div className='d-flex gap-2'>
              {UIHelper.buildFormLabel('Đơn giá sạc quá giờ', true, false)}
              <KTTooltip
                text={`<div>Là số chi phí khách hàng phải trả cho mỗi phút chưa rút súng sạc ra khỏi xe và đặt lại về trụ sạc</div>`}
                textHeader="Đơn giá sạc quá giờ "
                isHtmlContent
              >
                <i
                  className="fa-regular fa-info-circle"
                  style={{ color: AppColors.info }}
                />
              </KTTooltip>
            </div>
            <KTFormInput
              type={KTFormInputType.currency}
              unit="VNĐ/phút"
              placeholder="Nhập đơn giá sạc quá giờ"
              name="overchargePrice"
              value={activePricingConfig.overchargePrice}
              onChange={(value) => {
                updateActivePricingConfig({ overchargePrice: value });
              }}
            />
          </div>
        </div>
        <div className="col-lg-6 mb-4 px-2">
          <div>
            <div className='d-flex gap-2'>
              {UIHelper.buildFormLabel('Thời gian chờ miễn phí', true, false)}
              <KTTooltip
                text={`<div>Thời gian chờ miễn phí là thời gian sau khi xe đã sạc đầy nhưng chủ xe chưa đến hoàn thành rút súng sạc ra khỏi xe và đặt lại về trụ sạc</div>`}
                textHeader="Thời gian chờ miễn phí "
                isHtmlContent
              >
                <i
                  className="fa-regular fa-info-circle"
                  style={{ color: AppColors.info }}
                />
              </KTTooltip>
            </div>
            <KTFormInput
              type={KTFormInputType.currency}
              unit="Phút"
              placeholder="Nhập thời gian chờ miễn phí"
              name="freeOverchargeDuration"
              value={activePricingConfig.freeOverchargeDuration}
              onChange={(value) => {
                updateActivePricingConfig({ freeOverchargeDuration: value });
              }}
            />
          </div>
        </div>
      </div>

      {/* co che tinh gia dien */}
      <div className="mt-2">
        {UIHelper.buildCardHeader('Cơ chế tính giá sạc', false, null, true)}
      </div>
      <div className="row m-0 p-0 px-2"
        style={{
          borderBottom: `1px dashed ${AppColors.gray[300]}`,
        }}
      >
        <div className="col-lg-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Phương thức tính giá', true)}
            <KTBSDropdown
              name="pricingMode"
              toggleElement={
                <button
                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                  type="button"
                >
                  {activePricingConfig.pricingMode
                    ? _.find(
                      ChargeHelper.Data.chargePointPricingModeOptions,
                      (item) => item?.value === activePricingConfig.pricingMode
                    )?.name
                    : 'Chọn cách tính giá điện'}
                </button>
              }
              selectedValue={activePricingConfig.pricingMode}
              dropdownMenuItems={ChargeHelper.Data.chargePointPricingModeOptions}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                updateActivePricingConfig({ pricingMode: value });
              }}
              isDropdownForm={true}
            />
          </div>
        </div>
        {activePricingConfig.pricingMode === ChargeConstants.ChargePricingMode.FLAT && (
          <div className="col-lg-6 mb-4 px-2">
            <div>
              <div className='d-flex gap-2'>
                {UIHelper.buildFormLabel('Giá sạc cố định', true, false)}
              </div>
              <KTFormInput
                type={KTFormInputType.currency}
                unit="VNĐ/kWh"
                placeholder="Nhập giá sạc cố định"
                name="flatPrice"
                value={activePricingConfig.flatPrice}
                onChange={(value) => {
                  updateActivePricingConfig({ flatPrice: value });
                }}
              />
            </div>
          </div>
        )}
        {activePricingConfig.pricingMode === ChargeConstants.ChargePricingMode.HOURS && (
          <>
            <div className="col-lg-6 mb-4 px-2">
              <div>
                <div className='d-flex gap-2'>
                  {UIHelper.buildFormLabel('Giá giờ bình thường', true, false)}
                  <KTTooltip
                    text={`<div><div>• Từ thứ 2 đến thứ 7: 04:00 - 09:30, 11:30 - 17:00, 20:00 - 22:00</div>
                            <div>• Chủ nhật: 04:00 - 22:00</div></div>`}
                    textHeader="Giờ bình thường"
                    isHtmlContent
                  >
                    <i
                      className="fa-regular fa-info-circle"
                      style={{ color: AppColors.info }}
                    />
                  </KTTooltip>
                </div>
                <KTFormInput
                  type={KTFormInputType.currency}
                  unit="VNĐ/kWh"
                  placeholder="Nhập giá giờ bình thường"
                  name="normalPrice"
                  value={activePricingConfig.normalPrice}
                  onChange={(value) => {
                    updateActivePricingConfig({ normalPrice: value });
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 mb-4 px-2">
              <div>
                <div className='d-flex gap-2'>
                  {UIHelper.buildFormLabel('Giá giờ cao điểm', true, false)}
                  <KTTooltip
                    text={`<div><div>Từ thứ 2 đến thứ 7: 09:30 - 11:30, 17:00 - 20:00</div>
                        <div>Chủ nhật: không có</div></div>`}
                    textHeader="Giờ cao điểm"
                    isHtmlContent
                  >
                    <i
                      className="fa-regular fa-info-circle"
                      style={{ color: AppColors.info }}
                    />
                  </KTTooltip>
                </div>
                <KTFormInput
                  type={KTFormInputType.currency}
                  unit="VNĐ/kWh"
                  placeholder="Nhập giá giờ cao điểm"
                  name="peakPrice"
                  value={activePricingConfig.peakPrice}
                  onChange={(value) => {
                    updateActivePricingConfig({ peakPrice: value });
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 mb-4 px-2">
              <div>
                <div className='d-flex gap-2'>
                  {UIHelper.buildFormLabel('Giá giờ thấp điểm', true, false)}
                  <KTTooltip
                    text={`<div>Từ 22:00 - 04:00 tất cả các ngày trong tuần</div>`}
                    textHeader="Giờ thấp điểm"
                    isHtmlContent
                  >
                    <i
                      className="fa-regular fa-info-circle"
                      style={{ color: AppColors.info }}
                    />
                  </KTTooltip>
                </div>
                <KTFormInput
                  type={KTFormInputType.currency}
                  unit="VNĐ/kWh"
                  placeholder="Nhập giá giờ thấp điểm"
                  name="offPeakPrice"
                  value={activePricingConfig.offPeakPrice}
                  onChange={(value) => {
                    updateActivePricingConfig({ offPeakPrice: value });
                  }}
                />
              </div>
            </div>
          </>
        )}
        {/* Thuế suất - hiển thị cho tất cả các chế độ giá */}
        <div className="col-lg-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Thuế suất', true)}
            <KTBSDropdown
              name="taxRate"
              toggleElement={
                <button
                  className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                  type="button"
                >
                  {activePricingConfig.taxRate != null
                    ? activePricingConfig.taxRate === 'KCT'
                      ? 'KCT'
                      : `${activePricingConfig.taxRate}%`
                    : 'Chọn thuế suất'}
                </button>
              }
              selectedValue={activePricingConfig.taxRate}
              dropdownMenuItems={taxRateOptions}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                updateActivePricingConfig({ taxRate: value });
              }}
              isDropdownForm={true}
            />
          </div>
        </div>
      </div>

      {/* dat cho truoc */}
      <div className="p-4 d-flex gap-2 align-items-center">
        <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
          Đặt chỗ trước
        </div>
        {UIHelper.buildToggleSwitch(
          activePricingConfig.isReservationOn,
          handleToggleReservation
        )}
      </div>
      {activePricingConfig.isReservationOn && (
        <div className="row m-0 p-0 px-2">
          <div className="col-lg-6 mb-4 px-2">
            <div>
              <div className='d-flex gap-2'>
                {UIHelper.buildFormLabel('Phí đặt giữ chỗ', true, false)}
                <KTTooltip
                  text={`<div>Chi phí khi tài xế hủy giữ chỗ sau thời gian hủy miễn phí hoặc không đến sạc.</div>`}
                  textHeader="Phí đặt giữ chỗ"
                  isHtmlContent
                >
                  <i
                    className="fa-regular fa-info-circle"
                    style={{ color: AppColors.info }}
                  />
                </KTTooltip>
              </div>
              <KTFormInput
                type={KTFormInputType.currency}
                unit="VNĐ"
                placeholder="Nhập phí đặt giữ chỗ"
                name="reservationFee"
                value={activePricingConfig.reservationFee}
                onChange={(value) => {
                  updateActivePricingConfig({ reservationFee: value });
                }}
              />
            </div>
          </div>
          <div className="col-lg-6 mb-4 px-2">
            <div>
              <div className='d-flex gap-2'>
                {UIHelper.buildFormLabel('Thời gian hủy giữ chỗ miễn phí', true, false)}
                <KTTooltip
                  text={`<div>Thời gian tài xế được hủy giữ chỗ mà không mất phí đặt giữ chỗ, tính từ thời điểm đặt chỗ thành công (phút)</div>`}
                  textHeader="Thời gian hủy giữ chỗ miễn phí"
                  isHtmlContent
                >
                  <i
                    className="fa-regular fa-info-circle"
                    style={{ color: AppColors.info }}
                  />
                </KTTooltip>
              </div>
              <KTFormInput
                type={KTFormInputType.currency}
                unit="Phút"
                placeholder="Nhập thời gian hủy giữ chỗ miễn phí"
                name="reservationFreeCancellation"
                value={activePricingConfig.reservationFreeCancellation}
                onChange={(value) => {
                  updateActivePricingConfig({ reservationFreeCancellation: value });
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* actions */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          handleSubmit,
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddPricingView;
